import { render, staticRenderFns } from "./UnitMeasures.html?vue&type=template&id=4865a87c&external"
import script from "./UnitMeasures.js?vue&type=script&lang=js&external"
export * from "./UnitMeasures.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports